import _ from 'lodash';
import {
  archiveAllNotifications,
  fetchArchivedNotifications,
  fetchNotifications,
  fetchNotificationSettings,
  readAllNotifications,
  updateNotificationSettings,
} from '@/api/users';

export const getNotifications = (userId, params, isArchived = false) => {
  if (isArchived) {
    const archivedParams = _.omit(params, ['location']);

    return fetchArchivedNotifications(userId, archivedParams);
  }

  return fetchNotifications(userId, params);
};

export const getArchivedNotifications = (userId, params) => {
  return fetchArchivedNotifications(userId, params);
};

export const getNotificationSettings = (userId) => {
  return fetchNotificationSettings(userId);
};

export const toggleNotificationSettingOn = (userId, params) => {
  return updateNotificationSettings(userId, params);
};

export const markReadAllNotifications = ({ userId, location }) => {
  const params = {
    location,
  };

  return readAllNotifications(userId, params);
};

export const toggleArchiveAllNotifications = ({ userId, location }) => {
  const params = {
    location,
  };

  return archiveAllNotifications(userId, params);
};
